var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"getway-control-manage"},[_c('div',{staticClass:"scene-detail-area flex-auto"},[[_c('div',{staticClass:"getway-control-middle"},[_c('GetawayDetail',{ref:"getwayDetail"})],1)]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }